module.exports = __webpack_public_path__ + "static/logo-830711bb7bc06f3cb6acff001db9ee4c.png";